export default __webpack_public_path__ + "static/media/hk.b80f4f84.svg";